import { useAppRouting } from '@/Hooks/useAppRouting';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { purchasesPageSelectors } from '@/Pages/Purchases/services';
import { OrderTableRow } from '@/Types';
import { OrderType } from '@/Enums';

type UseSelectedOrdersRowsType = {
  orderRows: OrderTableRow[];
  orderIds: number[];
  isSalesPage: boolean;
  isPurchasesPage: boolean;
  orderType: OrderType;
};

export function useSelectedOrdersRows() {
  const { isSalesPage, isPurchasesPage } = useAppRouting();
  const sales = useSelector(salesPageSelectors.selectedSales);
  const purchases = useSelector(purchasesPageSelectors.selectedPurchases);

  return useMemo<UseSelectedOrdersRowsType>(() => {
    if (isSalesPage)
      return {
        orderRows: sales,
        orderIds: Array.from(new Set(sales.map((sale) => sale.id))),
        isSalesPage,
        isPurchasesPage,
        orderType: OrderType.Sale,
      };

    if (isPurchasesPage)
      return {
        orderRows: purchases,
        orderIds: Array.from(new Set(purchases.map((sale) => sale.id))),
        isSalesPage,
        isPurchasesPage,
        orderType: OrderType.Purchase,
      };

    return { orderRows: [], orderIds: [], isSalesPage: false, isPurchasesPage: false, orderType: OrderType.All };
  }, [isSalesPage, isPurchasesPage, sales, purchases]);
}
